import { useActiveChainId } from 'connection/useActiveChainId'
import { isSupportedChain } from 'constants/chains'

export default function useAutoRouterSupported(): boolean {
  const { chainId } = useActiveChainId()
  return isSupportedChain(chainId)
}
